import { gql } from 'graphql-request';

export const DELETE_MEETING_MUTATION = gql`
  mutation deleteMeeting($input: DeleteMeetingInput!) {
    deleteMeeting(input: $input) {
      ok
      error {
        code
        message
      }
    }
  }
`;
